import { jsx as _jsx } from "react/jsx-runtime";
import { usePlasmicCanvasContext } from "@plasmicapp/host";
import { useOfferRenderContext } from "./OfferRenderContext.js";
export const LGPresetOfferProps = {
    preset: {
        type: "choice",
        options: ["COMMON", "REMARKETING", "PROMOTED"],
        defaultValue: "COMMON",
        displayName: "Offer preset",
    },
    commonSlot: {
        type: "slot",
        displayName: "Common Offer Slot",
    },
    remarketingSlot: {
        type: "slot",
        displayName: "Remarketing Offer Slot",
    },
    promotedSlot: {
        type: "slot",
        displayName: "Promoted Offer Slot",
    },
};
export function LGPresetOffer({ preset, className, commonSlot, remarketingSlot, promotedSlot, }) {
    const { offer } = useOfferRenderContext();
    const inEditor = usePlasmicCanvasContext();
    function presetSlot(preset) {
        switch (preset) {
            case "COMMON":
                return commonSlot;
            case "REMARKETING":
                return remarketingSlot;
            case "PROMOTED":
                return promotedSlot;
            default:
                return null;
        }
    }
    if (!inEditor) {
        if (offer?.offerType === "preset") {
            return (_jsx("div", { id: `preset-offer-${offer.preset.toLowerCase().trim()}`, className: className, children: presetSlot(offer.preset) }));
        }
        return null;
    }
    return _jsx("div", { className: className, children: presetSlot(preset) });
}
